import {useEffect} from "react"
import {Hub} from "aws-amplify/utils"
import {toast} from "react-toastify"
import {useTranslation} from "react-i18next"
import {useSessionContext} from "./reactContext/contextCustomHooks/useSessionContext"
import {useTeamContext} from "./reactContext/contextCustomHooks/useTeamContext"
import currentAuthSession from "./aws/cognito/currentAuthSession"
import getTeam from "./axios/getTeam"
import {useNavigate} from "react-router-dom"

export default function AuthListener({children}) {
    const {t} = useTranslation()
    const navigate = useNavigate()
    const {setSessionAction} = useSessionContext()
    const {setTeamAction} = useTeamContext()

    useEffect(() => {

        const listener = ({payload}) => {
            switch (payload.event) {
                case "signedIn":
                    console.log("user have been signedIn successfully.")
                    break
                case "signedOut":
                    console.log("user have been signedOut successfully.")
                    break
                case "tokenRefresh":
                    console.log("auth tokens have been refreshed.")
                    break
                case "tokenRefresh_failure":
                    console.error("tokenRefresh_failure: failure while refreshing auth tokens.")
                    break
                case "signInWithRedirect":
                    console.log("signInWithRedirect API has successfully been resolved.")
                    currentAuthSession()
                    .then(async (response) => {
                        setSessionAction({
                            type: "LOGIN",
                            payload: {
                                isLogin: true,
                                idToken: response.idToken.toString(),
                                idUser: response.idToken.payload.id_user,
                                idTeam: response.idToken.payload.id_team,
                                role: response.idToken.payload.role,
                            }
                        })
                        await getTeam(response.idToken.toString(), response.idToken.payload.id_team).then((response) => {
                            setTeamAction({
                                type: "SET_TEAM_CONTEXT",
                                payload: {
                                    licencePackage: response.licence_package,
                                    licenceTypes: response.licence_types,
                                    licenceStartDate: response.licence_start_date,
                                    licenceEndDate: response.licence_end_date,
                                }
                            })
                        })
                        navigate("/")
                        toast.success(t("Welcome to Neurowide Studio"))
                    })
                    .catch((error) => {
                        console.error("currentAuthSession: ", error)
                    })
                    break
                case "signInWithRedirect_failure":
                    console.error("signInWithRedirect_failure: failure while trying to resolve signInWithRedirect API.")
                    if (payload.data.error.stack.slice(0, 90) === "OAuthSignInException: PreTokenGeneration failed with error No Associated User in Database.") {
                        toast.error(t("User not recognized by Neurowide-Studio."))
                    }
                    break
                case "customOAuthState":
                    console.log("custom state returned from CognitoHosted UI.")
                    break
                default:
                    break
            }
        }

        Hub.listen("auth", listener)
        return () => Hub.remove("auth", listener)
    },  [])

    return children
}